module.exports = __webpack_public_path__ + "static/media/logo-menu.6bdeee72.png";